import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeAnalyticAreasFilter } from '../../../ac/onChangeMapFilters';
import { AnalyticAreasFilterTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const AnalyticAreasFilterComponent = ({
    onChangeAnalyticAreasFilter,
    AnalyticArea,
}) => (
    <div>
        <div className={styles.legHead}>{t`Тип зоны`}:</div>
        <StandardRadioGroup
            value={String(AnalyticArea)}
            onChange={onChangeAnalyticAreasFilter}
        >
            {
                AnalyticAreasFilterTypes.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={AnalyticArea === value}
                                onChange={onChangeAnalyticAreasFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: AnalyticArea === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
        <small>{t`Аналитические слои для Москвы и Санкт-Петербурга`}</small>
    </div>
);
const mapStateToProps = ({ mapFilters: { AnalyticArea } }) => ({ AnalyticArea });
const ConnectedComponent = connect(mapStateToProps, { onChangeAnalyticAreasFilter })(AnalyticAreasFilterComponent);

export const AnalyticAreasFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    `${t`Аналитические зоны`}`
);
